export default __webpack_public_path__ + "static/media/farmakom_logo.bc493c6f.webp";